<template>
	<div class="home">
		<nav-header :xieyi="xieyi" ref="nav"></nav-header>
		<router-view style="flex: 1;"></router-view>
		<footer-box :xieyi="xieyi"></footer-box>
	</div>
</template>

<script>
	import navHeader from "../components/nav-header.vue"
	import footerBox from "../components/footer-box.vue"
	export default {
		data() {
			return {
				path: '',
				xieyi: false
			}
		},
		created() {
			setTimeout(() => {
				this.path = this.$route.path
				console.log(this.path);
				if(this.path == '/xieyi') {
					this.xieyi = false
				} else {
					this.xieyi = false
				}
			}, 800);
		},
		methods: {
			settitle(title){
				this.$refs.nav.settitle(title)
			}
		},
		components:{
			navHeader,
			footerBox
		}
	}
</script>

<style lang="scss">
.home{
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}
</style>